// extracted by mini-css-extract-plugin
export default {"title":"details-series-view_title__IgOTZ"};